export default __webpack_public_path__ + "static/media/b2.a18eeee0.jpg";